export default __webpack_public_path__ + "static/media/goodreads-logo-m.589d8362.svg";